import styled from 'styled-components';
import SpinnerIcon from '../../Generic/Icons/Svgs/Spinner';
import { animationRotate } from '../../Generic/Animations/index';

export const StyledRotatedSpinner = styled(SpinnerIcon)`
    animation: ${animationRotate} 0.6s linear infinite;
`;

export const StyledFullPageSpinner = styled(StyledRotatedSpinner)`
    height: 58px;
    width: 58px;
    position: fixed;
    left: calc(50vw - 29px);
    top: calc(50vh - 29px);
`;

export const StyledInlineSpinner = styled(StyledRotatedSpinner)`
    height: 40px;
    width: 40px;
    position: absolute;
    left: calc(50% - 20px);
    top: calc(50% - 20px);
`;
